import { createRouter, createWebHistory } from 'vue-router';
import qs from 'qs';

const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/:pathMatch(.*)*', component: { render: () => null } }
  ],

  parseQuery(query) {
    return qs.parse(query);
  },
  stringifyQuery(query) {
    return qs.stringify(query);
  }
});

export default router;